import { render, staticRenderFns } from "./YoukeXianshangXingweiFenxi.vue?vue&type=template&id=4dd4b313&scoped=true&"
import script from "./YoukeXianshangXingweiFenxi.vue?vue&type=script&lang=js&"
export * from "./YoukeXianshangXingweiFenxi.vue?vue&type=script&lang=js&"
import style0 from "./YoukeXianshangXingweiFenxi.vue?vue&type=style&index=0&id=4dd4b313&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd4b313",
  null
  
)

export default component.exports